@if (displaysCross) {
  <span class="kyb-lock-cross mdi mdi-close" [matTooltip]="tooltip"></span>
} @else {
  <span [matTooltip]="tooltip">
    <mat-checkbox
      [ngModel]="checked"
      [disabled]="locked || readonly"
      (ngModelChange)="onCheckedChange($event)">
    </mat-checkbox>
  </span>
}
